import React from "react"
import { Grid } from "@material-ui/core"

import { Breadcrumb } from "@/components"

import { Text, themeColors } from "letalkui"

type PageHeaderBreadcrumb = {
	name: string
	pathname: string
}

type PageHeaderProps = {
	title: string
	action: React.ReactNode
	breadcrumb: PageHeaderBreadcrumb
}

const PageHeader: React.FC<PageHeaderProps> = (props) => {
	const {
		title,
		action,
		breadcrumb
	} = props

	return (
		<Grid container direction="column" spacing={2}>
			<Grid item xs={12}>
				<Breadcrumb
					data={[
						{ name: breadcrumb.name, pathname: breadcrumb.pathname }
					]}
				/>
			</Grid>

			<Grid item xs={12}>
				<Grid
					container
					justifyContent="space-between"
					alignItems="center"
				>
					<Grid item>
						<Grid
							container
							alignItems="center"
							spacing={2}
						>
							<Grid item>
								<Grid container direction="column" spacing={2}>
									<Grid item>
										<Text.Title
											type="h1"
											fontWeight="bold"
											color={themeColors.colors.system.gray[900]}
										>
											{title}
										</Text.Title>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						{action}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default PageHeader
